/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_Feature_ComplianceInputs */



/**
* | output |
* | --- |
* | "Optional compliance per request" |
*
* @param {Gateway_Card_Feature_ComplianceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_feature_compliance = /** @type {((inputs?: Gateway_Card_Feature_ComplianceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_Feature_ComplianceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionale Compliance pro Anfrage")
	return /** @type {LocalizedString} */ ("Optional compliance per request")
});